/* global process */

/**
 * The add-in's configuration. Values come from the `.env` file (git-ignored), injected at build
 * time by webpack — so the API token is NOT committed to source control.
 *
 * ⚠️ A client add-in still ships these values to the browser: the token ends up readable in the
 * built bundle. `.env` keeps it out of git, not out of the delivered files. Treat the token as a
 * shared, rotatable key. Set the values in `.env` (see `.env.example`), then rebuild.
 */
export const CONFIG = {
  /** The AroundLink endpoint that files the message. Must be HTTPS. */
  apiUrl: process.env.AROUNDLINK_API_URL || "",

  /** Sent in the `X-AroundLink-Token` header (must match OUTLOOK_ADDIN_TOKEN on the server). */
  apiToken: process.env.AROUNDLINK_API_TOKEN || "",

  /**
   * Auto-send filter (pinned pane). When a message is opened, it is sent only if this word
   * appears in its subject or body (case-insensitive). Empty string = send every message.
   */
  keyword: process.env.AROUNDLINK_KEYWORD || "",
};
